

import { useEffect, useRef, useState } from "react";
import { Flex, Heading, Text, Box, Button } from "rebass/styled-components";
import { toast } from 'react-toastify';

import styled from "styled-components";
import moment from "moment";
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber";
import { useDetectOutsideClick } from "../../../hooks/useDetectOutsideClick";
import { IGetProviderPatientByIdOutput, IGetProviderPatientChartAlertOutput, IGethealthCoachPatientProfileMembershipsTagsInput, IGethealthCoachPatientProfileMembershipsTagsOutput, IgetHealthcoachStickyNoteOutput } from "../../../graphql/types/queries/patient";
import { isLocalMode, isPreviewMode } from "../../../utils/environment";
import { PickNewNote } from "./PickNewNote";
import { useNavigate } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useSetIsHealthCoachingEnabled } from "../../../graphql/hooks/mutations/useSetIsHealthCoachEnabled";
import { useMutation, useQuery } from "@apollo/client";
import { GET_INTAKE_STATUS, GET_PATIENT_CONVERSATIONS_LIST, GET_PATIENT_MEMBERSHIPS_TAGS } from "../../../graphql/queries";
import { EnhancedModal } from "../../../components/EnhancedModal";
import { MembershipTags } from "./MembershipTags";
import { boolean } from "yup";
import { IGetIntakeStatusOutput, IGetIntakeStatusInput } from "../../../graphql/types/queries/appointment";
import Modal from "styled-react-modal";
import { SpecialModalBackground } from "../../../components/Commons";
import { GENERATE_WEBTOKEN_FOR_IMPERSONATE, INIT_MEMBER_CONVO } from "../../../graphql/mutations";
import { IGenerateWebTokenFromHCOutput, IGenerateWebTokenFromHCInput } from "../../../graphql/types/mutations/login";
import SendSms from "../../../components/SendSms";
import { useSetHealthCoachStatus } from "../../../graphql/hooks/mutations/useSetHealthCoachStatus";
import Select, { ActionMeta, components } from "react-select";
import { ReactSelectStyles } from "../../../styles/ReactSelectStyles";
import { RbCircledChecked, RbCircledUnchecked } from "../../../components/RadioButton";
import { RequestReplacementKit } from "./RequestReplacementKit";
import { WellnessPlan } from "./WellnessPlan";
import { IHealthCoachGetPatientConversationsListOutput, IHealthCoachGetPatientConversationsListInput } from "../../../graphql/types/queries/conversation";
import { ViewListConversations } from "../../messages/components/ViewListConversations";
import { IhealthCoachInitMemberConvoInput, IhealthCoachInitMemberConvoOutput } from "../../../graphql/types/mutations/conversation";

const MenuContainer = styled(Box)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`

const MenuTrigger = styled(Box)`
  background: #4463CF;
  border-radius: 90px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border: none;
  vertical-align: middle;
  transition: box-shadow 0.4s ease;
  margin-left: auto; /* Strictly for positioning */
  &:hover {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  }
`

const ProviderBox = styled(Flex) <{ isExpanded: boolean }>`
  display: flex;
  @media screen and (max-width: 1900px) {
  display: ${(props) => props.isExpanded ? 'none' : 'flex'};
  }

  @media screen and (max-width: 1600px) {
  display: ${(props) => props.isExpanded ? 'none' : 'flex'};
  }

  @media screen and (max-width: 1400px) {
  display: none;
  }
`

const ReversedProviderBox = styled(Flex) <{ isExpanded: boolean }>`
display: none;

@media screen and (max-width: 1600px) {
display: ${(props) => !props.isExpanded ? 'none' : 'flex'};
flex: 1;
}

@media screen and (max-width: 1400px) {
display: flex;
flex: 1;
}
`

const TagsBox = styled(Flex) <{ isExpanded: boolean }>`
display: flex;

@media screen and (max-width: 1600px) {
display: ${(props) => props.isExpanded ? 'none' : 'flex'};
}
`
const ProviderBoxReplace = styled(Flex) <{ isExpanded: boolean }>`
display: none;

@media screen and (max-width: 1900px) {
  display: ${(props) => props.isExpanded ? 'flex' : 'none'};
  flex: 1;
  }
@media screen and (max-width: 1600px) {
display: ${(props) => props.isExpanded ? 'flex' : 'none'};
flex: 1;
}

@media screen and (max-width: 1400px) {
display: flex;
flex: 1;
}
`

const MenuEntry = styled.div`
  padding: 17px 28px;
  background-color: #4463CF !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.37);
  color: white;
  &:hover {
    background: #344F7A;
    cursor: pointer;
    &.disabled {
    background-color: red !important;
    cursor: not-allowed;
    }
  }
  &:not(:hover) {
    background: #4463CF;

  /* &.disabled {
    background: #6b80cc:
    cursor: not-allowed;
  } */
  }
  /* &:not(:hover) .disabled {
    background-color: red !important;
    cursor: not-allowed;
  } */
  
`
const Menu = styled.div`
  /* background: red; */
  border-radius: 8px;
  position: absolute;
  top: 60px;
  right: 0;
  width: 300px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  z-index:1000;
  overflow: hidden;
  visibility: hidden;
  transform: translateY(-20px);
  transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
  &.active {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  top: 60px;
  }
  >${MenuEntry} {
    border-bottom: 1px solid rgba(255, 255, 255, 0.37);
    background-color: #4463CF;
    cursor: pointer;
    transition: background 0.4s ease;
    user-select: none;
  &.disabled {
  background: #6b80cc !important;
      cursor: not-allowed;
  }
  }
`
interface IProps {
  data: IGetProviderPatientChartAlertOutput | undefined,
  dataPatient: IGetProviderPatientByIdOutput,
  patientName: string,
  chartAlertRef: React.MutableRefObject<any>,
  HcStickyNoteRef: React.MutableRefObject<any>,
  isMinimized?: boolean
  isMessagesExpanded: boolean
  createChartAlert?: () => void
  createHcSticky: () => void
  dataHealthcoachStickyNote?: IgetHealthcoachStickyNoteOutput | undefined
}
enum EOptionsResourcesValues {
  'active',
  'yes',
  'maybe',
  'completed',
  'ineligible',
}
interface IOptionsResources {
  value: string
  label: string;
  disabled?: boolean
}
const optionsResources: Array<IOptionsResources> = [
  { value: 'active', label: 'Active' },
  { value: 'completed', label: 'Completed' },
  { value: 'interested', label: 'Interested' },
  { value: 'paused', label: 'Paused' },
  { value: 'no', label: 'No' },
  { value: 'ineligible', label: 'Ineligible' },
  { value: 'disengaged', label: 'Disengaged' },
  { value: 'yes', label: 'Yes', disabled: true },
  { value: 'maybe', label: 'Maybe', disabled: true },
]
const Tag = styled(Flex)`
  min-width: 28px;
  height: 28px;
  margin-right: 12px;
  padding-left: 3px ;
  padding-right: 3px ;
  justify-content: center;
  align-items: center;
`

const Option = (props: any) => {
  console.log('opt', props)
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'} style={{ opacity: props.isDisabled || props.disabled ? 0.3 : 1 }}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

const PageTopBar: React.FC<IProps> = ({ data, createHcSticky, dataPatient, patientName, chartAlertRef, HcStickyNoteRef, isMinimized, isMessagesExpanded, createChartAlert, dataHealthcoachStickyNote }) => {
  const toastId = useRef<any>(null);
  const [showListConversations, setShowListConversations] = useState(false)
  const [isPickForm, setIsPickForm] = useState(false)
  const [isSendSms, setIsSendSms] = useState(false)
  const [isSendReplacementKit, setIsSendReplacementKit] = useState(false)
  const [isIntakeWarningVisible, setIsIntakeWarningVisible] = useState(false)
  const [isUnableToActivateHC, setIsUnableToActivateHC] = useState(false)
  const [isShowingWellnessPlan, setIsShowingWellnessPlan] = useState(false)

  const dropdownRef = useRef(null);
  const navigate = useNavigate()
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const { data: dataMemberships, error, loading: loadingMemberships } = useQuery<IGethealthCoachPatientProfileMembershipsTagsOutput, IGethealthCoachPatientProfileMembershipsTagsInput>(GET_PATIENT_MEMBERSHIPS_TAGS, {
    variables: {
      athenaId: dataPatient.getProviderPatientById!.athenaId
    }
  });
  const { data: dataIntakeStatus, loading: loadingIntakeStatus } = useQuery<IGetIntakeStatusOutput, IGetIntakeStatusInput>(GET_INTAKE_STATUS, {
    variables: {
      athenaId: dataPatient.getProviderPatientById!.athenaId
    }
  });
  const { data: dataPatientConvos, loading: loadingPatientConvos } = useQuery<IHealthCoachGetPatientConversationsListOutput, IHealthCoachGetPatientConversationsListInput>(GET_PATIENT_CONVERSATIONS_LIST, {
    variables: {
      patientId: dataPatient.getProviderPatientById!.athenaId || ''
    }
  })

  const [impersonate] = useMutation<IGenerateWebTokenFromHCOutput, IGenerateWebTokenFromHCInput>(GENERATE_WEBTOKEN_FOR_IMPERSONATE, {
    onCompleted: (data) => {
      if (!data || !data.generateWebTokenFromHC || !data.generateWebTokenFromHC.token) {
        toast.update(toastId.current, {
          render: (<Flex flexDirection={'column'}>
            <Text fontWeight={400}>An error occured</Text>
          </Flex>),
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
        return
      }
      if (toastId && toastId.current) {
        toast.update(toastId.current, {
          render: (<Flex flexDirection={'column'}>
            <Text fontWeight={400}>Impersonation prerequisite successful</Text>
          </Flex>),
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.success(<Flex flexDirection={'column'}>
          <Text fontWeight={400}>Impersonation prerequisite successful</Text>
        </Flex>, {
          autoClose: 5000
        })
      }

      window.open(`${(window as any)._env_.REACT_APP_WEBAPP_URL}/hc/autosign/sso/${data.generateWebTokenFromHC.token}/${dataPatient.getProviderPatientById!.athenaId}`, '_blank')
    },
    onError: () => {
      if (toastId && toastId.current) {
        toast.update(toastId.current, {
          render: (<Flex flexDirection={'column'}>
            <Text fontWeight={400}>An error occured</Text>
          </Flex>),
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.error(<Flex flexDirection={'column'}>
          <Text fontWeight={400}>An error occured</Text>
        </Flex>, {
          autoClose: 5000
        })
      }
    }
  })
  const { mutate: setIsHealthCoachEnabled } = useSetIsHealthCoachingEnabled({
    athenaId: dataPatient.getProviderPatientById!.athenaId,
    onCompleted: (e) => {
      if (e && e.setIsHealthCoachingEnabled && e.setIsHealthCoachingEnabled.ok) {
        if (toastId && toastId.current) {
          toast.update(toastId.current, {
            render: (<Flex flexDirection={'column'}>
              <Text fontWeight={400}>Health coaching flag updated</Text>
            </Flex>),
            type: toast.TYPE.SUCCESS,
            isLoading: false,
            autoClose: 5000,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
        } else {
          toast.success(<Flex flexDirection={'column'}>
            <Text fontWeight={400}>Health coaching flag updated</Text>
          </Flex>, {
            autoClose: 5000
          })
        }
      } else {
        if (toastId && toastId.current) {
          toast.update(toastId.current, {
            render: (<Flex flexDirection={'column'}>
              <Text fontWeight={400}>An error occured</Text>
            </Flex>),
            type: toast.TYPE.ERROR,
            isLoading: false,
            autoClose: 5000,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
        } else {
          toast.error(<Flex flexDirection={'column'}>
            <Text fontWeight={400}>An error occured</Text>
          </Flex>, {
            autoClose: 5000
          })
        }
      }
    },
    onError: () => {
      if (toastId && toastId.current) {
        toast.update(toastId.current, {
          render: (<Flex flexDirection={'column'}>
            <Text fontWeight={400}>An error occured</Text>
          </Flex>),
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.error(<Flex flexDirection={'column'}>
          <Text fontWeight={400}>An error occured</Text>
        </Flex>, {
          autoClose: 5000
        })
      }
    }
  })


  const { mutate: setHealthCoachStatus } = useSetHealthCoachStatus({
    athenaId: dataPatient.getProviderPatientById!.athenaId,
    onCompleted: (e) => {
      if (e && e.setHealthCoachingStatus && e.setHealthCoachingStatus.ok) {
        if (toastId && toastId.current) {
          toast.update(toastId.current, {
            render: (<Flex flexDirection={'column'}>
              <Text fontWeight={400}>Health coaching status updated</Text>
            </Flex>),
            type: toast.TYPE.SUCCESS,
            isLoading: false,
            autoClose: 5000,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
        } else {
          toast.success(<Flex flexDirection={'column'}>
            <Text fontWeight={400}>Health coaching status updated</Text>
          </Flex>, {
            autoClose: 5000
          })
        }
      } else {
        if (toastId && toastId.current) {
          toast.update(toastId.current, {
            render: (<Flex flexDirection={'column'}>
              <Text fontWeight={400}>An error occured</Text>
            </Flex>),
            type: toast.TYPE.ERROR,
            isLoading: false,
            autoClose: 5000,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
        } else {
          toast.error(<Flex flexDirection={'column'}>
            <Text fontWeight={400}>An error occured</Text>
          </Flex>, {
            autoClose: 5000
          })
        }
      }
    },
    onError: () => {
      if (toastId && toastId.current) {
        toast.update(toastId.current, {
          render: (<Flex flexDirection={'column'}>
            <Text fontWeight={400}>An error occured</Text>
          </Flex>),
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.error(<Flex flexDirection={'column'}>
          <Text fontWeight={400}>An error occured</Text>
        </Flex>, {
          autoClose: 5000
        })
      }
    }
  })

  const [initMemberConvoMutate] = useMutation<IhealthCoachInitMemberConvoOutput, IhealthCoachInitMemberConvoInput>(INIT_MEMBER_CONVO, {
    onCompleted: (data) => {
      if (!data || !data.healthCoachInitMemberConvo || !data.healthCoachInitMemberConvo.ok) {
        toast.update(toastId.current, {
          render: (<Flex flexDirection={'column'}>
            <Text fontWeight={400}>{(data?.healthCoachInitMemberConvo?.customError) || 'An error occured'}</Text>
          </Flex>),
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
        return
      }
      if (toastId && toastId.current) {
        toast.update(toastId.current, {
          render: (<Flex flexDirection={'column'}>
            <Text fontWeight={400}>Member conversation initialized</Text>
          </Flex>),
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.success(<Flex flexDirection={'column'}>
          <Text fontWeight={400}>Member conversation initialized</Text>
        </Flex>, {
          autoClose: 5000
        })
      }

    },
    onError: () => {
      if (toastId && toastId.current) {
        toast.update(toastId.current, {
          render: (<Flex flexDirection={'column'}>
            <Text fontWeight={400}>An error occured</Text>
          </Flex>),
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.error(<Flex flexDirection={'column'}>
          <Text fontWeight={400}>An error occured</Text>
        </Flex>, {
          autoClose: 5000
        })
      }
    }
  })

  const onClick = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    console.log('onclick', isActive)
    setIsActive(!isActive)
  };

  const membershipData = loadingMemberships ? null : dataMemberships?.gethealthCoachPatientProfileMembershipsTags?.memberships.find(
    x => x.subscriptionTarget === 'SUBSCRIPTION_MEMBERSHIP' || x.subscriptionTarget === 'SUBSCRIPTION_GI'
  );

  let webappRoute = 'https://app.palomahealth.com'
  if (isPreviewMode) {
    webappRoute = !isLocalMode ? 'https://preview-app.paloma.network' : 'http://localhost:3000'
  }
  // console.log({dataHealthcoachStickyNote: (dataHealthcoachStickyNote || {} as any).getHealthcoachStickyNote})
  return (
    <Flex flex={1}>

      <Flex flexDirection={'column'}>

        <Flex flexDirection={'row'} mb={[3, 0, 0]} alignItems={'center'}>
          <Heading style={{ textDecoration: 'underline', cursor: 'pointer' }} ml={[0, 2, 2]} mr={3}
            onClick={() => {
              navigate(`/patient/${dataPatient.getProviderPatientById!.athenaId}`)
            }}>{`${patientName}`}
          </Heading>
          {data && data.getProviderPatientChartAlert ? (
            <Flex
              ref={chartAlertRef}
              data-event="click"
              justifyContent={'center'}
              alignItems='center'
              padding={'0px'}
              alignSelf='center'
              mr={3}
              data-tip
              data-for='chartAlertTooltip'
              style={{ backgroundColor: "#fccc00", borderBottomLeftRadius: '10px' }}>
              <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00195 11.0001C7.00195 10.8688 7.02782 10.7388 7.07807 10.6174C7.12833 10.4961 7.20199 10.3859 7.29485 10.293C7.38771 10.2002 7.49794 10.1265 7.61927 10.0762C7.7406 10.026 7.87063 10.0001 8.00195 10.0001C8.13328 10.0001 8.26331 10.026 8.38464 10.0762C8.50596 10.1265 8.6162 10.2002 8.70906 10.293C8.80192 10.3859 8.87558 10.4961 8.92583 10.6174C8.97609 10.7388 9.00195 10.8688 9.00195 11.0001C9.00195 11.2653 8.8966 11.5197 8.70906 11.7072C8.52152 11.8948 8.26717 12.0001 8.00195 12.0001C7.73674 12.0001 7.48238 11.8948 7.29485 11.7072C7.10731 11.5197 7.00195 11.2653 7.00195 11.0001V11.0001ZM7.09995 4.99512C7.08664 4.86896 7.09999 4.74141 7.13915 4.62075C7.17831 4.50008 7.24241 4.389 7.32727 4.2947C7.41214 4.20041 7.51588 4.12501 7.63176 4.0734C7.74765 4.02179 7.87309 3.99512 7.99995 3.99512C8.12681 3.99512 8.25226 4.02179 8.36814 4.0734C8.48403 4.12501 8.58777 4.20041 8.67263 4.2947C8.7575 4.389 8.82159 4.50008 8.86075 4.62075C8.89991 4.74141 8.91327 4.86896 8.89995 4.99512L8.54995 8.50212C8.53573 8.63808 8.47166 8.76396 8.37009 8.85546C8.26852 8.94696 8.13666 8.99759 7.99995 8.99759C7.86325 8.99759 7.73139 8.94696 7.62982 8.85546C7.52825 8.76396 7.46417 8.63808 7.44995 8.50212L7.09995 4.99512Z" fill="black" />
              </svg>

            </Flex>
          ) : (
            <Flex
              onClick={() => {
                console.log('CREATE ATHENA NOTE')
                if (createChartAlert) {
                  createChartAlert()
                }
              }}
              // onClick={createChartAlert}
              justifyContent={'center'}
              alignItems='center'
              padding={'0px'}
              alignSelf='center'
              mr={3}
              style={{ backgroundColor: "#c3c3c2", borderBottomLeftRadius: '10px', cursor: 'pointer' }}>
              <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00195 11.0001C7.00195 10.8688 7.02782 10.7388 7.07807 10.6174C7.12833 10.4961 7.20199 10.3859 7.29485 10.293C7.38771 10.2002 7.49794 10.1265 7.61927 10.0762C7.7406 10.026 7.87063 10.0001 8.00195 10.0001C8.13328 10.0001 8.26331 10.026 8.38464 10.0762C8.50596 10.1265 8.6162 10.2002 8.70906 10.293C8.80192 10.3859 8.87558 10.4961 8.92583 10.6174C8.97609 10.7388 9.00195 10.8688 9.00195 11.0001C9.00195 11.2653 8.8966 11.5197 8.70906 11.7072C8.52152 11.8948 8.26717 12.0001 8.00195 12.0001C7.73674 12.0001 7.48238 11.8948 7.29485 11.7072C7.10731 11.5197 7.00195 11.2653 7.00195 11.0001V11.0001ZM7.09995 4.99512C7.08664 4.86896 7.09999 4.74141 7.13915 4.62075C7.17831 4.50008 7.24241 4.389 7.32727 4.2947C7.41214 4.20041 7.51588 4.12501 7.63176 4.0734C7.74765 4.02179 7.87309 3.99512 7.99995 3.99512C8.12681 3.99512 8.25226 4.02179 8.36814 4.0734C8.48403 4.12501 8.58777 4.20041 8.67263 4.2947C8.7575 4.389 8.82159 4.50008 8.86075 4.62075C8.89991 4.74141 8.91327 4.86896 8.89995 4.99512L8.54995 8.50212C8.53573 8.63808 8.47166 8.76396 8.37009 8.85546C8.26852 8.94696 8.13666 8.99759 7.99995 8.99759C7.86325 8.99759 7.73139 8.94696 7.62982 8.85546C7.52825 8.76396 7.46417 8.63808 7.44995 8.50212L7.09995 4.99512Z" fill="black" />
              </svg>

            </Flex>
          )}


          {dataHealthcoachStickyNote && dataHealthcoachStickyNote.getHealthcoachStickyNote && dataHealthcoachStickyNote.getHealthcoachStickyNote.note ? (
            <Flex
              ref={HcStickyNoteRef}
              data-event="click"
              justifyContent={'center'}
              alignItems='center'
              padding={'0px'}
              alignSelf='center'
              mr={3}
              data-tip
              data-for='HcStickyNoteRefTooltip'
              style={{ backgroundColor: "#02da1b", borderBottomLeftRadius: '10px' }}>
              <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00195 11.0001C7.00195 10.8688 7.02782 10.7388 7.07807 10.6174C7.12833 10.4961 7.20199 10.3859 7.29485 10.293C7.38771 10.2002 7.49794 10.1265 7.61927 10.0762C7.7406 10.026 7.87063 10.0001 8.00195 10.0001C8.13328 10.0001 8.26331 10.026 8.38464 10.0762C8.50596 10.1265 8.6162 10.2002 8.70906 10.293C8.80192 10.3859 8.87558 10.4961 8.92583 10.6174C8.97609 10.7388 9.00195 10.8688 9.00195 11.0001C9.00195 11.2653 8.8966 11.5197 8.70906 11.7072C8.52152 11.8948 8.26717 12.0001 8.00195 12.0001C7.73674 12.0001 7.48238 11.8948 7.29485 11.7072C7.10731 11.5197 7.00195 11.2653 7.00195 11.0001V11.0001ZM7.09995 4.99512C7.08664 4.86896 7.09999 4.74141 7.13915 4.62075C7.17831 4.50008 7.24241 4.389 7.32727 4.2947C7.41214 4.20041 7.51588 4.12501 7.63176 4.0734C7.74765 4.02179 7.87309 3.99512 7.99995 3.99512C8.12681 3.99512 8.25226 4.02179 8.36814 4.0734C8.48403 4.12501 8.58777 4.20041 8.67263 4.2947C8.7575 4.389 8.82159 4.50008 8.86075 4.62075C8.89991 4.74141 8.91327 4.86896 8.89995 4.99512L8.54995 8.50212C8.53573 8.63808 8.47166 8.76396 8.37009 8.85546C8.26852 8.94696 8.13666 8.99759 7.99995 8.99759C7.86325 8.99759 7.73139 8.94696 7.62982 8.85546C7.52825 8.76396 7.46417 8.63808 7.44995 8.50212L7.09995 4.99512Z" fill="black" />
              </svg>

            </Flex>
          ) : (
            <Flex
              onClick={() => {
                console.log('CREATE HC NOTE')
                createHcSticky()
              }}
              justifyContent={'center'}
              alignItems='center'
              padding={'0px'}
              alignSelf='center'
              mr={3}
              style={{ backgroundColor: "#c3c3c2", borderBottomLeftRadius: '10px', cursor: 'pointer' }}>
              <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00195 11.0001C7.00195 10.8688 7.02782 10.7388 7.07807 10.6174C7.12833 10.4961 7.20199 10.3859 7.29485 10.293C7.38771 10.2002 7.49794 10.1265 7.61927 10.0762C7.7406 10.026 7.87063 10.0001 8.00195 10.0001C8.13328 10.0001 8.26331 10.026 8.38464 10.0762C8.50596 10.1265 8.6162 10.2002 8.70906 10.293C8.80192 10.3859 8.87558 10.4961 8.92583 10.6174C8.97609 10.7388 9.00195 10.8688 9.00195 11.0001C9.00195 11.2653 8.8966 11.5197 8.70906 11.7072C8.52152 11.8948 8.26717 12.0001 8.00195 12.0001C7.73674 12.0001 7.48238 11.8948 7.29485 11.7072C7.10731 11.5197 7.00195 11.2653 7.00195 11.0001V11.0001ZM7.09995 4.99512C7.08664 4.86896 7.09999 4.74141 7.13915 4.62075C7.17831 4.50008 7.24241 4.389 7.32727 4.2947C7.41214 4.20041 7.51588 4.12501 7.63176 4.0734C7.74765 4.02179 7.87309 3.99512 7.99995 3.99512C8.12681 3.99512 8.25226 4.02179 8.36814 4.0734C8.48403 4.12501 8.58777 4.20041 8.67263 4.2947C8.7575 4.389 8.82159 4.50008 8.86075 4.62075C8.89991 4.74141 8.91327 4.86896 8.89995 4.99512L8.54995 8.50212C8.53573 8.63808 8.47166 8.76396 8.37009 8.85546C8.26852 8.94696 8.13666 8.99759 7.99995 8.99759C7.86325 8.99759 7.73139 8.94696 7.62982 8.85546C7.52825 8.76396 7.46417 8.63808 7.44995 8.50212L7.09995 4.99512Z" fill="black" />
              </svg>

            </Flex>
          )}

          {!loadingIntakeStatus && dataIntakeStatus && !!dataIntakeStatus.healthCoachGetIntakeStatus && !!dataIntakeStatus.healthCoachGetIntakeStatus.notOk && (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setIsIntakeWarningVisible(true)} style={{ cursor: 'pointer', marginRight: '16px' }}>
              <path d="M22.2 17.6335L14.0016 3.39569C13.7967 3.04687 13.5042 2.75764 13.1532 2.55668C12.8021 2.35572 12.4046 2.25 12 2.25C11.5955 2.25 11.198 2.35572 10.8469 2.55668C10.4958 2.75764 10.2033 3.04687 9.99847 3.39569L1.80003 17.6335C1.60291 17.9709 1.49902 18.3546 1.49902 18.7454C1.49902 19.1361 1.60291 19.5199 1.80003 19.8572C2.00228 20.2082 2.29425 20.499 2.64599 20.6998C2.99773 20.9006 3.39658 21.0043 3.80159 21.0001H20.1985C20.6032 21.0039 21.0016 20.9001 21.353 20.6993C21.7044 20.4985 21.9961 20.2079 22.1982 19.8572C22.3956 19.52 22.4998 19.1364 22.5001 18.7456C22.5004 18.3549 22.3969 17.9711 22.2 17.6335ZM11.25 9.75006C11.25 9.55115 11.329 9.36038 11.4697 9.21973C11.6104 9.07908 11.8011 9.00006 12 9.00006C12.1989 9.00006 12.3897 9.07908 12.5304 9.21973C12.671 9.36038 12.75 9.55115 12.75 9.75006V13.5001C12.75 13.699 12.671 13.8897 12.5304 14.0304C12.3897 14.171 12.1989 14.2501 12 14.2501C11.8011 14.2501 11.6104 14.171 11.4697 14.0304C11.329 13.8897 11.25 13.699 11.25 13.5001V9.75006ZM12 18.0001C11.7775 18.0001 11.56 17.9341 11.375 17.8105C11.19 17.6868 11.0458 17.5111 10.9607 17.3056C10.8755 17.1 10.8532 16.8738 10.8966 16.6556C10.9401 16.4374 11.0472 16.2369 11.2045 16.0796C11.3619 15.9222 11.5623 15.8151 11.7806 15.7717C11.9988 15.7283 12.225 15.7505 12.4305 15.8357C12.6361 15.9208 12.8118 16.065 12.9354 16.25C13.059 16.4351 13.125 16.6526 13.125 16.8751C13.125 17.1734 13.0065 17.4596 12.7955 17.6706C12.5845 17.8815 12.2984 18.0001 12 18.0001Z" fill="#b02828" />
            </svg>
          )}

          <Flex
            onClick={() => setIsShowingWellnessPlan(true)}
            alignSelf='center' ml={3} mr={3} style={{ padding: '4px', borderRadius: 4, backgroundColor: 'rgb(33, 150, 243)', alignItems: 'center', justifyContent: 'center' }}>
            {/* <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 19V20L14 22.5L7 20.56V22H1V11H8.97L15.13 13.3C15.6789 13.5071 16.1518 13.8763 16.4858 14.3585C16.8198 14.8408 16.9992 15.4133 17 16H19C20.66 16 22 17.34 22 19ZM5 20V13H3V20H5ZM19.9 18.57C19.74 18.24 19.39 18 19 18H13.65C13.11 18 12.58 17.92 12.07 17.75L9.69 16.96L10.32 15.06L12.7 15.85C13 15.95 15 16 15 16C15 15.63 14.77 15.3 14.43 15.17L8.61 13H7V18.5L13.97 20.41L19.9 18.57Z" fill="white" />
              <path d="M23.8756 6.60187C23.816 6.48982 23.7363 6.3916 23.6409 6.31294C23.5455 6.23428 23.4365 6.17677 23.3201 6.14375C22.8981 6.02745 22.4619 5.98067 22.0267 6.005C22.26 4.76438 22.085 3.78313 21.91 3.20125C21.8386 2.96226 21.6868 2.76027 21.484 2.63458C21.2813 2.50889 21.0421 2.4685 20.8131 2.52125C20.2194 2.66285 19.6549 2.91958 19.1474 3.27875C18.7757 2.46543 18.2346 1.75444 17.5657 1.20062C17.4037 1.0704 17.2065 1 17.0039 1C16.8013 1 16.6041 1.0704 16.4421 1.20062C15.7722 1.75408 15.23 2.4651 14.8575 3.27875C14.35 2.91958 13.7855 2.66285 13.1918 2.52125C12.9628 2.46823 12.7236 2.50852 12.5209 2.63426C12.3182 2.75999 12.1665 2.96215 12.0955 3.20125C11.9205 3.78313 11.7454 4.76375 11.9753 6.005C11.5401 5.98067 11.1039 6.02745 10.6818 6.14375C10.5655 6.17677 10.4565 6.23428 10.3611 6.31294C10.2657 6.3916 10.1859 6.48982 10.1264 6.60187C10.0642 6.71658 10.0239 6.8434 10.0078 6.97495C9.99182 7.1065 10.0004 7.24016 10.0331 7.36812C10.2308 8.15437 10.8382 9.64875 12.6778 10.8263C14.5173 12.0038 16.1334 12 17.0039 12C17.8744 12 19.4934 12 21.3213 10.8263C23.1609 9.64875 23.7682 8.15437 23.966 7.36812C23.9991 7.24036 24.0082 7.10682 23.9926 6.97527C23.9771 6.84372 23.9373 6.7168 23.8756 6.60187ZM13.1562 9.96813C11.6025 8.97313 11.0978 7.75312 10.9333 7.10625C11.3625 6.99269 11.8081 6.96787 12.246 7.03312C12.3922 7.45268 12.5708 7.85846 12.7799 8.24625C13.2932 9.19431 13.9657 10.0326 14.7635 10.7188C14.1994 10.5449 13.659 10.2926 13.1562 9.96813ZM17.001 10.9C16.4566 10.4662 15.134 9.13562 15.134 6.44812C15.134 3.79375 16.4397 2.4525 17.001 2C17.5622 2.45375 18.868 3.795 18.868 6.44938C18.868 9.13563 17.5453 10.4662 17.001 10.9ZM23.0687 7.1075C22.9071 7.7475 22.4036 8.97063 20.8464 9.96813C20.3435 10.2924 19.8031 10.5445 19.239 10.7181C20.0368 10.0319 20.7093 9.19369 21.2227 8.24562C21.4318 7.85783 21.6104 7.45206 21.7565 7.0325C22.1944 6.96789 22.6397 6.99313 23.0687 7.10688V7.1075Z" fill="white" />
            </svg> */}
            <svg
              xmlns="http://www.w3.org/2000/svg" width="18" height="18"
              viewBox="0 0 48 48">
              <ellipse cx="20.51" cy="23.56" fill="none" strokeWidth={'2'} stroke="white" stroke-linecap="round" stroke-linejoin="round" rx="4.22" ry="10.21" transform="rotate(-20 20.523 23.56)" />
              <ellipse cx="14.75" cy="28.84" strokeWidth={'2'} fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" rx="4.22" ry="10.21" transform="rotate(-65 14.751 28.839)" />
              <ellipse cx="27.49" cy="23.56" strokeWidth={'2'} fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" rx="10.21" ry="4.22" transform="rotate(-70 27.495 23.562)" />
              <ellipse cx="33.25" cy="28.84" strokeWidth={'2'} fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" rx="10.21" ry="4.22" transform="rotate(-25 33.242 28.831)" />
            </svg>
          </Flex>

          {!isMinimized && dataPatient?.getProviderPatientById?.athenaId && (
            <TagsBox isExpanded={isMessagesExpanded}>
              <MembershipTags athenaId={dataPatient?.getProviderPatientById?.athenaId} />
            </TagsBox>
          )}

          {!isMinimized && dataPatient?.getProviderPatientById?.forceBypassBridge && (
            <TagsBox isExpanded={isMessagesExpanded}>
              <Tag onClick={onClick} style={{ background: '#d86767' }} title="Force Bypass Bridge active">
                <svg width="18" height="18" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2" d="M108.75 78.75H11.25V54.0703C16.7913 51.8287 21.5366 47.9829 24.8774 43.0261C28.2181 38.0693 30.0019 32.2275 30 26.25C30 34.2065 33.1607 41.8371 38.7868 47.4632C44.4129 53.0893 52.0435 56.25 60 56.25C67.9565 56.25 75.5871 53.0893 81.2132 47.4632C86.8393 41.8371 90 34.2065 90 26.25C89.9981 32.2275 91.7819 38.0693 95.1226 43.0261C98.4634 47.9829 103.209 51.8287 108.75 54.0703V78.75Z" fill="white" />
                  <path d="M108.75 75H93.75V47.5031C97.355 51.9502 102.033 55.4057 107.344 57.5438C108.262 57.8975 109.282 57.8763 110.184 57.4848C111.087 57.0933 111.799 56.3629 112.168 55.451C112.537 54.539 112.533 53.5187 112.157 52.6098C111.78 51.7009 111.062 50.9763 110.156 50.5922C105.3 48.6426 101.14 45.2804 98.2147 40.9407C95.2898 36.601 93.7345 31.4834 93.75 26.25C93.75 25.2554 93.3549 24.3016 92.6517 23.5984C91.9484 22.8951 90.9946 22.5 90 22.5C89.0054 22.5 88.0516 22.8951 87.3483 23.5984C86.6451 24.3016 86.25 25.2554 86.25 26.25C86.25 33.2119 83.4844 39.8887 78.5616 44.8116C73.6387 49.7344 66.9619 52.5 60 52.5C53.0381 52.5 46.3613 49.7344 41.4384 44.8116C36.5156 39.8887 33.75 33.2119 33.75 26.25C33.75 25.2554 33.3549 24.3016 32.6516 23.5984C31.9484 22.8951 30.9946 22.5 30 22.5C29.0054 22.5 28.0516 22.8951 27.3484 23.5984C26.6451 24.3016 26.25 25.2554 26.25 26.25C26.2655 31.4834 24.7102 36.601 21.7853 40.9407C18.8603 45.2804 14.7004 48.6426 9.84375 50.5922C8.9381 50.9763 8.21964 51.7009 7.84326 52.6098C7.46688 53.5187 7.46272 54.539 7.83167 55.451C8.20062 56.3629 8.91314 57.0933 9.81563 57.4848C10.7181 57.8763 11.7383 57.8975 12.6562 57.5438C17.9667 55.4057 22.645 51.9502 26.25 47.5031V75H11.25C10.2554 75 9.30161 75.3951 8.59835 76.0983C7.89509 76.8016 7.5 77.7554 7.5 78.75C7.5 79.7446 7.89509 80.6984 8.59835 81.4017C9.30161 82.1049 10.2554 82.5 11.25 82.5H26.25V93.75C26.25 94.7446 26.6451 95.6984 27.3484 96.4017C28.0516 97.1049 29.0054 97.5 30 97.5C30.9946 97.5 31.9484 97.1049 32.6516 96.4017C33.3549 95.6984 33.75 94.7446 33.75 93.75V82.5H86.25V93.75C86.25 94.7446 86.6451 95.6984 87.3483 96.4017C88.0516 97.1049 89.0054 97.5 90 97.5C90.9946 97.5 91.9484 97.1049 92.6517 96.4017C93.3549 95.6984 93.75 94.7446 93.75 93.75V82.5H108.75C109.745 82.5 110.698 82.1049 111.402 81.4017C112.105 80.6984 112.5 79.7446 112.5 78.75C112.5 77.7554 112.105 76.8016 111.402 76.0983C110.698 75.3951 109.745 75 108.75 75ZM67.5 59.1562V75H52.5V59.1562C57.4367 60.2814 62.5633 60.2814 67.5 59.1562ZM33.75 47.4375C36.8103 51.2189 40.6467 54.2993 45 56.4703V75H33.75V47.4375ZM75 75V56.475C79.3533 54.3039 83.1897 51.2236 86.25 47.4422V75H75Z" fill="white" />
                  <path d="M2 23L112 98" stroke="black" stroke-width="5" />
                </svg>
              </Tag>
            </TagsBox>
          )}

        </Flex>

        <Flex mt={3} alignItems={'baseline'}>
          <Flex flexDirection={'column'} width={'100%'}>
            <Flex width={'100%'}>
              <Text mr={2} fontSize={'14px'} fontWeight={300}>ID:</Text>
              <Text mr={4} fontSize={'18px'} fontWeight={600}>{dataPatient?.getProviderPatientById?.athenaId}</Text>
              <Text mr={2} fontSize={'18px'} fontWeight={600}>{dataPatient?.getProviderPatientById?.dob ? moment().diff(moment(dataPatient?.getProviderPatientById?.dob, 'MM/DD/YYYY'), 'year') : ''}</Text>
              <Text mr={2} fontSize={'14px'} fontWeight={300}>yo</Text>
              {dataPatient?.getProviderPatientById?.dob && (
                <Text mr={4} fontSize={'14px'} fontWeight={300}>{`(${dataPatient?.getProviderPatientById?.dob})`}</Text>
              )}
              <Flex flex={1} >&nbsp;</Flex>
              {!!isMinimized && !!dataPatient.getProviderPatientById!.athenaId && !loadingPatientConvos && dataPatientConvos && dataPatientConvos.healthCoachGetPatientConversationsList && dataPatientConvos.healthCoachGetPatientConversationsList.length > 0 && (
                <Button onClick={() => setShowListConversations(true)} variant={'outline'} style={{ width: 'fit-content', padding: '4px 12px', height: 'fit-content', border: 0, paddingTop: 0 }}>
                  <Flex flexDirection={'row'} alignItems={'center'}>
                    <svg height='24' viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.3029 6.5H10.6971C9.6815 6.49998 8.84402 6.49995 8.18121 6.58907C7.48533 6.68262 6.87076 6.8866 6.37868 7.37868C5.8866 7.87076 5.68262 8.48533 5.58907 9.18121C5.49995 9.84402 5.49998 10.6815 5.5 11.697V12.3029C5.49998 13.3185 5.49995 14.156 5.58907 14.8188C5.68262 15.5147 5.8866 16.1292 6.37868 16.6213C6.87076 17.1134 7.48533 17.3174 8.18121 17.4109C8.84402 17.5001 9.68147 17.5 10.6971 17.5H13.3029C14.3185 17.5 15.156 17.5001 15.8188 17.4109C16.5147 17.3174 17.1292 17.1134 17.6213 16.6213C18.1134 16.1292 18.3174 15.5147 18.4109 14.8188C18.5001 14.156 18.5 13.3185 18.5 12.303V11.6971C18.5 10.6815 18.5001 9.84402 18.4109 9.18121C18.3174 8.48533 18.1134 7.87076 17.6213 7.37868C17.1292 6.8866 16.5147 6.68262 15.8188 6.58907C15.156 6.49995 14.3185 6.49998 13.3029 6.5ZM7.43934 8.43934C7.60627 8.27241 7.85154 8.14689 8.38108 8.07569C8.93219 8.0016 9.66814 8 10.75 8H13.25C14.3319 8 15.0678 8.0016 15.6189 8.07569C16.1485 8.14689 16.3937 8.27241 16.5607 8.43934C16.6527 8.53142 16.7322 8.64733 16.7969 8.82164L15.2392 9.88374C14.3391 10.4974 13.7136 10.9226 13.19 11.2009C12.6829 11.4705 12.3345 11.5665 12 11.5665C11.6655 11.5665 11.3172 11.4705 10.81 11.2009C10.2864 10.9226 9.66092 10.4974 8.76083 9.88374L7.20307 8.82163C7.26779 8.64733 7.34727 8.53142 7.43934 8.43934ZM7.00707 10.5035C7.00031 10.8606 7 11.2715 7 11.75V12.25C7 13.3319 7.0016 14.0678 7.07569 14.6189C7.14689 15.1485 7.27241 15.3937 7.43934 15.5607C7.60627 15.7276 7.85154 15.8531 8.38108 15.9243C8.93219 15.9984 9.66814 16 10.75 16H13.25C14.3319 16 15.0678 15.9984 15.6189 15.9243C16.1485 15.8531 16.3937 15.7276 16.5607 15.5607C16.7276 15.3937 16.8531 15.1485 16.9243 14.6189C16.9984 14.0678 17 13.3319 17 12.25V11.75C17 11.2715 16.9997 10.8606 16.9929 10.5035L16.0489 11.1472C15.1925 11.7311 14.4992 12.2038 13.894 12.5255C13.2642 12.8603 12.6681 13.0665 12 13.0665C11.332 13.0665 10.7359 12.8603 10.106 12.5255C9.50086 12.2038 8.80752 11.7311 7.95113 11.1472L7.00707 10.5035Z"
                        fill="#314351">
                      </path>
                    </svg>
                    <Text style={{
                      textDecoration: dataPatientConvos.healthCoachGetPatientConversationsList.filter(x => x.status === 'active').length > 0 ? 'underline' : '',
                      fontWeight: dataPatientConvos.healthCoachGetPatientConversationsList.filter(x => x.status === 'active').length > 0 ? 600 : 300,
                    }}>

                      ({dataPatientConvos.healthCoachGetPatientConversationsList.length})
                    </Text>
                  </Flex>
                </Button>
              )}
            </Flex>

            <TagsBox isExpanded={isMessagesExpanded}>
              {!!dataPatient?.getProviderPatientById?.preferredPronouns && (
                <Text fontWeight={300} fontSize='14px' mr={2}>{`(${dataPatient?.getProviderPatientById.preferredPronouns})`}</Text>
              )}
              {!!dataPatient?.getProviderPatientById?.sex && (
                <Text fontWeight={300} fontSize='14px' mr={3}>{`${dataPatient?.getProviderPatientById.sex ? dataPatient?.getProviderPatientById.sex === 'F' ? 'Female' : 'Male' : ''}`}</Text>
              )}
            </TagsBox>
          </Flex>
          {!isMinimized && dataPatient?.getProviderPatientById?.startedAIPOn && (
            <>

              <ReversedProviderBox isExpanded={isMessagesExpanded} />
              <ProviderBox isExpanded={isMessagesExpanded}>
                <Text mr={4} fontSize={'14px'} fontWeight={300}>{`Started AIP Program on ${moment(dataPatient?.getProviderPatientById?.startedAIPOn).format('MM/DD/YYYY')} (${moment().diff(moment(dataPatient?.getProviderPatientById?.startedAIPOn), 'weeks')} weeks ago)`}</Text>
              </ProviderBox>
            </>
          )}
          {/* {!isMinimized && (
            <>
              <svg style={{ alignSelf: 'center' }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.8495 12.1C12.6828 12.2666 12.4995 12.3083 12.2995 12.225C12.0995 12.1416 11.9995 11.9833 11.9995 11.75V3.94995C11.9995 3.66662 12.0955 3.42895 12.2875 3.23695C12.4795 3.04495 12.7168 2.94929 12.9995 2.94995H19.9995C20.2828 2.94995 20.5205 3.04595 20.7125 3.23795C20.9045 3.42995 21.0002 3.66729 20.9995 3.94995V8.94995C20.9995 9.23329 20.9035 9.47095 20.7115 9.66295C20.5195 9.85495 20.2822 9.95062 19.9995 9.94995H14.9995L12.8495 12.1ZM19.9495 21C17.7995 21 15.7038 20.5206 13.6625 19.562C11.6212 18.6033 9.81285 17.3366 8.23751 15.762C6.66218 14.1873 5.39551 12.379 4.43751 10.337C3.47951 8.29495 3.00018 6.19929 2.99951 4.04995C2.99951 3.74995 3.09951 3.49995 3.29951 3.29995C3.49951 3.09995 3.74951 2.99995 4.04951 2.99995H8.09951C8.33285 2.99995 8.54118 3.07495 8.72451 3.22495C8.90785 3.37495 9.01618 3.56662 9.04951 3.79995L9.69951 7.29995C9.73284 7.53329 9.72851 7.74595 9.68651 7.93795C9.64451 8.12995 9.54884 8.30062 9.39951 8.44995L6.99951 10.9C7.69951 12.1 8.57451 13.225 9.62451 14.275C10.6745 15.325 11.8328 16.2333 13.0995 17L15.4495 14.65C15.5995 14.5 15.7955 14.3876 16.0375 14.313C16.2795 14.2383 16.5168 14.2173 16.7495 14.25L20.1995 14.95C20.4328 15 20.6245 15.1126 20.7745 15.288C20.9245 15.4633 20.9995 15.6673 20.9995 15.9V19.95C20.9995 20.25 20.8995 20.5 20.6995 20.7C20.4995 20.9 20.2495 21 19.9495 21Z" fill="#344F7A" />
              </svg>
              <Text fontSize={'14px'} fontWeight={300} ml={2}>{formatPhoneNumber(dataPatient?.getProviderPatientById?.phone)}</Text>
            </>
          )} */}
        </Flex>
      </Flex>
      {!isMinimized ? (
        <>
          <ProviderBoxReplace isExpanded={isMessagesExpanded} ></ProviderBoxReplace>
          <ProviderBox isExpanded={isMessagesExpanded} ml={3} pl={3} flexDirection={'column'} flex={1} style={{ borderLeft: '1px solid rgba(78, 101, 138, 0.56)', borderRight: '1px solid rgba(78, 101, 138, 0.56)' }}>
            <Flex alignItems={'center'}>
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.04898 12.675C6.72466 12.323 4.05371 11.3358 4.05371 9.09662C4.05371 6.11892 7.68749 2.02703 7.68749 2.02703C7.68749 2.02703 8.8706 0 12.199 0C15.5267 0 17.2274 2.02703 17.2274 2.02703C17.2274 2.02703 19.5943 4.68041 19.5943 9.09662C19.5943 11.3723 18.2591 12.2959 16.9652 12.6574C15.9138 13.9074 14.2929 14.7 12.4997 14.7C10.7145 14.7 9.10101 13.9155 8.04898 12.675ZM8.44222 10.7547C9.06655 12.2574 10.626 13.3493 12.4997 13.3493C13.2699 13.3493 13.9868 13.1642 14.6078 12.8426L14.5652 12.8378C14.5652 12.8378 18.6044 8.94054 15.2024 4.05405C14.8328 3.36689 9.20371 5.06757 8.4456 6.08108C7.9902 6.68919 8.20101 9.00338 8.44222 10.7547Z" fill="#344F7A" />
                <path d="M5.69748 19.2176C5.28984 19.4673 4.98357 19.8531 4.83278 20.3067C4.682 20.7604 4.6964 21.2527 4.87345 21.6968C5.05049 22.1409 5.37879 22.508 5.80034 22.7335C6.22188 22.959 6.70955 23.0282 7.17719 22.9289C7.64483 22.8297 8.06234 22.5683 8.35596 22.1911C8.64958 21.8138 8.80042 21.3449 8.78183 20.8673C8.76324 20.3896 8.57641 19.9338 8.25436 19.5805C7.9323 19.2272 7.49575 18.9991 7.02181 18.9365C6.99649 18.8459 6.97329 18.7546 6.95221 18.6629C6.85982 18.2454 6.78766 17.8238 6.736 17.3994C6.68018 16.9704 6.6486 16.5386 6.6414 16.1061C6.64 15.9873 6.64338 15.8685 6.65154 15.75C6.911 15.6757 7.17181 15.6081 7.43194 15.5494C7.72992 15.4818 7.90694 15.8331 8.04951 16.1183L8.05694 16.1331L8.10762 16.2325H16.0461C16.2009 15.9392 16.5515 15.4717 16.8914 15.5494C17.2536 15.6318 17.6178 15.7298 17.9786 15.8419L17.9765 15.8426C17.9752 15.8412 17.9752 15.8412 17.9765 15.844C17.9792 15.8534 17.9941 15.898 18.009 15.9926C18.0259 16.1021 18.0373 16.244 18.0428 16.4149C18.0522 16.7554 18.0326 17.1696 17.9928 17.5872C17.9522 18.0041 17.8921 18.4075 17.8245 18.7257C17.8096 18.7967 17.7948 18.8608 17.7799 18.919H16.8914C16.766 18.919 16.643 18.954 16.5363 19.02C16.4296 19.086 16.3434 19.1804 16.2873 19.2926L15.6117 20.644C15.5647 20.7377 15.5401 20.8411 15.5401 20.946V22.2973C15.5401 22.4765 15.6112 22.6484 15.738 22.7751C15.8647 22.9018 16.0365 22.973 16.2157 22.973H17.5671V21.6217H16.8914V21.1054L17.309 20.2703H19.1765L19.5941 21.1054V21.6217H18.9184V22.973H20.2698C20.449 22.973 20.6208 22.9018 20.7476 22.7751C20.8743 22.6484 20.9455 22.4765 20.9455 22.2973V20.946C20.9454 20.8411 20.9208 20.7377 20.8738 20.644L20.1982 19.2926C20.1421 19.1804 20.0559 19.086 19.9492 19.02C19.8425 18.954 19.7196 18.919 19.5941 18.919H19.1644C19.2367 18.5588 19.2968 18.1385 19.3373 17.7169C19.3819 17.2615 19.4049 16.7892 19.3934 16.3771L19.3928 16.3581C22.0873 17.4967 24.3238 19.369 24.3238 21.3311V25H-0.000488281V21.3311C-0.000488281 19.2825 2.4387 17.3311 5.29073 16.2115C5.29816 16.6318 5.33803 17.1068 5.39546 17.5669C5.45762 18.0635 5.54208 18.5575 5.63532 18.9642C5.65559 19.0514 5.67586 19.1358 5.69748 19.2176Z" fill="#344F7A" />
                <path d="M6.75624 21.6319C7.11976 21.6319 7.43192 21.3346 7.43192 20.9461C7.43192 20.5582 7.11976 20.2603 6.75624 20.2603C6.39273 20.2603 6.08057 20.5576 6.08057 20.9461C6.08057 21.3339 6.39273 21.6319 6.75624 21.6319Z" fill="#344F7A" />
              </svg>

              <Text ml={3} fontWeight={300} fontSize={'14px'} >{dataPatient?.getProviderPatientById?.primaryProvider || 'no primary provider set'}</Text>
            </Flex>
            <Flex mt={2} alignItems={'center'}>
              <svg width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.7495 17.5H16.2495V13.75H19.9995V11.25H16.2495V7.5H13.7495V11.25H9.99951V13.75H13.7495V17.5ZM14.9995 27.5C11.6453 24.6458 9.14035 21.995 7.48451 19.5475C5.82868 17.1 5.00035 14.8342 4.99951 12.75C4.99951 9.625 6.00493 7.13542 8.01576 5.28125C10.0266 3.42708 12.3545 2.5 14.9995 2.5C17.6453 2.5 19.9737 3.42708 21.9845 5.28125C23.9953 7.13542 25.0003 9.625 24.9995 12.75C24.9995 14.8333 24.1712 17.0992 22.5145 19.5475C20.8578 21.9958 18.3528 24.6467 14.9995 27.5Z" fill="#344F7A" />
              </svg>
              <Text ml={3} fontWeight={300} fontSize={'14px'} >{`${dataPatient?.getProviderPatientById?.providerGroupName || 'no provider group set'}, ${dataPatient?.getProviderPatientById?.fullStateName}`}</Text>
            </Flex>
            {!!dataPatient.getProviderPatientById!.athenaId && !loadingPatientConvos && dataPatientConvos && dataPatientConvos.healthCoachGetPatientConversationsList && dataPatientConvos.healthCoachGetPatientConversationsList.length > 0 && (
              <Flex mt={2} onClick={() => setShowListConversations(true)} alignItems={'center'} style={{ cursor: 'pointer' }}>
                <svg height='30' viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.3029 6.5H10.6971C9.6815 6.49998 8.84402 6.49995 8.18121 6.58907C7.48533 6.68262 6.87076 6.8866 6.37868 7.37868C5.8866 7.87076 5.68262 8.48533 5.58907 9.18121C5.49995 9.84402 5.49998 10.6815 5.5 11.697V12.3029C5.49998 13.3185 5.49995 14.156 5.58907 14.8188C5.68262 15.5147 5.8866 16.1292 6.37868 16.6213C6.87076 17.1134 7.48533 17.3174 8.18121 17.4109C8.84402 17.5001 9.68147 17.5 10.6971 17.5H13.3029C14.3185 17.5 15.156 17.5001 15.8188 17.4109C16.5147 17.3174 17.1292 17.1134 17.6213 16.6213C18.1134 16.1292 18.3174 15.5147 18.4109 14.8188C18.5001 14.156 18.5 13.3185 18.5 12.303V11.6971C18.5 10.6815 18.5001 9.84402 18.4109 9.18121C18.3174 8.48533 18.1134 7.87076 17.6213 7.37868C17.1292 6.8866 16.5147 6.68262 15.8188 6.58907C15.156 6.49995 14.3185 6.49998 13.3029 6.5ZM7.43934 8.43934C7.60627 8.27241 7.85154 8.14689 8.38108 8.07569C8.93219 8.0016 9.66814 8 10.75 8H13.25C14.3319 8 15.0678 8.0016 15.6189 8.07569C16.1485 8.14689 16.3937 8.27241 16.5607 8.43934C16.6527 8.53142 16.7322 8.64733 16.7969 8.82164L15.2392 9.88374C14.3391 10.4974 13.7136 10.9226 13.19 11.2009C12.6829 11.4705 12.3345 11.5665 12 11.5665C11.6655 11.5665 11.3172 11.4705 10.81 11.2009C10.2864 10.9226 9.66092 10.4974 8.76083 9.88374L7.20307 8.82163C7.26779 8.64733 7.34727 8.53142 7.43934 8.43934ZM7.00707 10.5035C7.00031 10.8606 7 11.2715 7 11.75V12.25C7 13.3319 7.0016 14.0678 7.07569 14.6189C7.14689 15.1485 7.27241 15.3937 7.43934 15.5607C7.60627 15.7276 7.85154 15.8531 8.38108 15.9243C8.93219 15.9984 9.66814 16 10.75 16H13.25C14.3319 16 15.0678 15.9984 15.6189 15.9243C16.1485 15.8531 16.3937 15.7276 16.5607 15.5607C16.7276 15.3937 16.8531 15.1485 16.9243 14.6189C16.9984 14.0678 17 13.3319 17 12.25V11.75C17 11.2715 16.9997 10.8606 16.9929 10.5035L16.0489 11.1472C15.1925 11.7311 14.4992 12.2038 13.894 12.5255C13.2642 12.8603 12.6681 13.0665 12 13.0665C11.332 13.0665 10.7359 12.8603 10.106 12.5255C9.50086 12.2038 8.80752 11.7311 7.95113 11.1472L7.00707 10.5035Z"
                    fill="#314351">
                  </path>
                </svg>

                <Text style={{ textDecoration: 'underline' }} ml={3} fontWeight={300} fontSize={'14px'}>
                  View Patient's {dataPatientConvos.healthCoachGetPatientConversationsList.length} conversations {dataPatientConvos.healthCoachGetPatientConversationsList.filter(x => x.status === 'active').length > 0 ? <span style={{ fontWeight: 600 }}>({dataPatientConvos.healthCoachGetPatientConversationsList.filter(x => x.status === 'active').length} active)</span> : ''}
                </Text>
              </Flex>
            )}
          </ProviderBox>
        </>
      ) : (
        <Box flex={1} style={{ borderRight: '1px solid rgba(78, 101, 138, 0.56)' }} />
      )}

      {!!dataPatient && !!dataPatient.getProviderPatientById && (
        <Flex flexDirection={'column'} ml={2}>
          {dataPatient?.getProviderPatientById?.isHealthCoachEnabled ? (
            <svg
              style={{ cursor: 'pointer' }}
              onClick={() => {
                toastId.current = toast(<Flex flexDirection={'column'}>
                  <Text fontWeight={400}>Health Coaching status change</Text>
                  <Text fontWeight={300}>Disabling health coaching for patient {dataPatient.getProviderPatientById?.athenaId}</Text>
                </Flex>, { autoClose: false, isLoading: true, closeButton: false });

                setIsHealthCoachEnabled({
                  variables: {
                    athenaId: dataPatient.getProviderPatientById!.athenaId,
                    isEnabled: false
                  }
                })
              }}
              width="140" height="66" viewBox="0 0 140 66" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M120 54.9231V13.0769C120 12.2609 119.422 11.4782 118.393 10.9012C117.364 10.3242 115.968 10 114.513 10H18.4872C17.0319 10 15.6362 10.3242 14.6072 10.9012C13.5781 11.4782 13 12.2609 13 13.0769V54.9231C13 55.7391 13.5781 56.5218 14.6072 57.0988C15.6362 57.6758 17.0319 58 18.4872 58H114.513C115.968 58 117.364 57.6758 118.393 57.0988C119.422 56.5218 120 55.7391 120 54.9231Z" fill="#2196F3" stroke="#2196F3" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M61.0488 19.1914V30.1914M61.0488 25.6539C61.0512 24.9252 61.368 24.227 61.9301 23.7118C62.4922 23.1965 63.2539 22.9061 64.0488 22.9039C64.8437 22.9061 65.6054 23.1965 66.1675 23.7118C66.7296 24.227 67.0465 24.9252 67.0488 25.6539V30.1914M102.95 19.1914V30.1914M102.95 25.6539C102.952 24.9252 103.269 24.227 103.831 23.7118C104.393 23.1965 105.155 22.9061 105.95 22.9039C106.745 22.9061 107.506 23.1965 108.069 23.7118C108.631 24.227 108.947 24.9252 108.95 25.6539V30.1914M100.704 35.8069V46.8069M100.704 42.2694C100.707 41.5407 101.024 40.8425 101.586 40.3273C102.148 39.812 102.909 39.5216 103.704 39.5194C104.499 39.5216 105.261 39.812 105.823 40.3273C106.385 40.8425 106.702 41.5407 106.704 42.2694V46.8069M97.4763 20.5664V30.1914M95.8263 22.9039H98.9763M76.5753 28.8164C76.3237 29.234 75.9543 29.582 75.5057 29.8239C75.0571 30.0658 74.5458 30.1927 74.0253 30.1914C73.2304 30.1892 72.4687 29.8988 71.9066 29.3835C71.3445 28.8683 71.0277 28.1701 71.0253 27.4414V25.6539C71.0277 24.9252 71.3445 24.227 71.9066 23.7118C72.4687 23.1965 73.2304 22.9061 74.0253 22.9039C74.8202 22.9061 75.5819 23.1965 76.144 23.7118C76.7061 24.227 77.023 24.9252 77.0253 25.6539V26.6164H71.0253M91.4913 19.1914V28.8164C91.4793 28.9999 91.5099 29.1835 91.581 29.3554C91.6521 29.5272 91.7622 29.6832 91.9039 29.8132C92.0457 29.9431 92.2159 30.044 92.4034 30.1092C92.5908 30.1744 92.7912 30.2024 92.9913 30.1914H93.4413M67.5483 45.4319C67.2968 45.8496 66.9274 46.1977 66.4788 46.4396C66.0302 46.6815 65.5188 46.8084 64.9983 46.8069C64.2034 46.8047 63.4417 46.5143 62.8796 45.999C62.3175 45.4838 62.0007 44.7856 61.9983 44.0569V42.2694C62.0007 41.5407 62.3175 40.8425 62.8796 40.3273C63.4417 39.812 64.2034 39.5216 64.9983 39.5194C65.5188 39.518 66.0302 39.6448 66.4788 39.8867C66.9274 40.1286 67.2968 40.4767 67.5483 40.8944M96.7473 45.4319C96.4957 45.8495 96.1263 46.1975 95.6777 46.4394C95.2291 46.6813 94.7178 46.8082 94.1973 46.8069C93.4024 46.8047 92.6407 46.5143 92.0786 45.999C91.5165 45.4838 91.1997 44.7856 91.1973 44.0569V42.2694C91.1997 41.5407 91.5165 40.8425 92.0786 40.3273C92.6407 39.812 93.4024 39.5216 94.1973 39.5194C94.7178 39.5181 95.2291 39.645 95.6777 39.8869C96.1263 40.1288 96.4957 40.4768 96.7473 40.8944M87.0018 27.4414C86.9995 28.1701 86.6826 28.8683 86.1205 29.3835C85.5584 29.8988 84.7967 30.1892 84.0018 30.1914C83.2069 30.1892 82.4452 29.8988 81.8831 29.3835C81.321 28.8683 81.0042 28.1701 81.0018 27.4414V25.6539C81.0042 24.9252 81.321 24.227 81.8831 23.7118C82.4452 23.1965 83.2069 22.9061 84.0018 22.9039C84.7967 22.9061 85.5584 23.1965 86.1205 23.7118C86.6826 24.227 86.9995 24.9252 87.0018 25.6539M87.0018 30.1914V22.9039M87.2388 44.0569C87.2365 44.7856 86.9196 45.4838 86.3575 45.999C85.7954 46.5143 85.0337 46.8047 84.2388 46.8069C83.4439 46.8047 82.6822 46.5143 82.1201 45.999C81.558 45.4838 81.2412 44.7856 81.2388 44.0569V42.2694C81.2412 41.5407 81.558 40.8425 82.1201 40.3273C82.6822 39.812 83.4439 39.5216 84.2388 39.5194C85.0337 39.5216 85.7954 39.812 86.3575 40.3273C86.9196 40.8425 87.2365 41.5407 87.2388 42.2694M87.2388 46.8069V39.5194M74.5053 46.8069C73.7104 46.8047 72.9487 46.5143 72.3866 45.999C71.8245 45.4838 71.5077 44.7856 71.5053 44.0569V42.2694C71.5077 41.5407 71.8245 40.8425 72.3866 40.3273C72.9487 39.812 73.7104 39.5216 74.5053 39.5194C75.3002 39.5216 76.0619 39.812 76.624 40.3273C77.1861 40.8425 77.503 41.5407 77.5053 42.2694V44.0569C77.503 44.7856 77.1861 45.4838 76.624 45.999C76.0619 46.5143 75.3002 46.8047 74.5053 46.8069Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M34.3979 37.9755C34.1747 38.1987 33.8818 38.3109 33.5888 38.3109C33.2958 38.3109 33.0029 38.1987 32.7797 37.9755L28.202 33.3979C27.7546 32.9504 27.7546 32.2272 28.202 31.7797C28.6495 31.3322 29.3728 31.3322 29.8202 31.7797L33.5888 35.5482L43.1446 25.9924C41.0538 23.7207 38.0646 22.2891 34.7332 22.2891C28.4126 22.2891 23.2891 27.4126 23.2891 33.7332C23.2891 40.0538 28.4126 45.1773 34.7332 45.1773C41.0538 45.1773 46.1773 40.0538 46.1773 33.7332C46.1773 31.576 45.5697 29.5652 44.5317 27.8418L34.3979 37.9755Z" fill="white" />
            </svg>
          ) : (
            <svg
              style={{
                cursor: 'pointer'
              }}
              onClick={() => {
                if (dataPatient.getProviderPatientById?.athenaId) {
                  toastId.current = toast(<Flex flexDirection={'column'}>
                    <Text fontWeight={400}>Health Coaching status change</Text>
                    <Text fontWeight={300}>Enabling health coaching for patient {dataPatient.getProviderPatientById?.athenaId}</Text>
                  </Flex>, { autoClose: false, isLoading: true, closeButton: false });

                  setIsHealthCoachEnabled({
                    variables: {
                      athenaId: dataPatient.getProviderPatientById!.athenaId,
                      isEnabled: true
                    }
                  })
                } else {
                  setIsUnableToActivateHC(true)
                }
              }} width="127" height="66" viewBox="0 0 127 66" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M121 54.9231V13.0769C121 12.2609 120.416 11.4782 119.378 10.9012C118.339 10.3242 116.93 10 115.462 10H18.5385C17.0696 10 15.6608 10.3242 14.6222 10.9012C13.5835 11.4782 13 12.2609 13 13.0769V54.9231C13 55.7391 13.5835 56.5218 14.6222 57.0988C15.6608 57.6758 17.0696 58 18.5385 58H115.462C116.93 58 118.339 57.6758 119.378 57.0988C120.416 56.5218 121 55.7391 121 54.9231Z" stroke="#2196F3" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M61.0488 19.1914V30.1914M61.0488 25.6539C61.0512 24.9252 61.368 24.227 61.9301 23.7118C62.4922 23.1965 63.2539 22.9061 64.0488 22.9039C64.8437 22.9061 65.6054 23.1965 66.1675 23.7118C66.7296 24.227 67.0465 24.9252 67.0488 25.6539V30.1914M102.95 19.1914V30.1914M102.95 25.6539C102.952 24.9252 103.269 24.227 103.831 23.7118C104.393 23.1965 105.155 22.9061 105.95 22.9039C106.745 22.9061 107.506 23.1965 108.069 23.7118C108.631 24.227 108.947 24.9252 108.95 25.6539V30.1914M100.704 35.8069V46.8069M100.704 42.2694C100.707 41.5407 101.024 40.8425 101.586 40.3273C102.148 39.812 102.909 39.5216 103.704 39.5194C104.499 39.5216 105.261 39.812 105.823 40.3273C106.385 40.8425 106.702 41.5407 106.704 42.2694V46.8069M97.4763 20.5664V30.1914M95.8263 22.9039H98.9763M76.5753 28.8164C76.3237 29.234 75.9543 29.582 75.5057 29.8239C75.0571 30.0658 74.5458 30.1927 74.0253 30.1914C73.2304 30.1892 72.4687 29.8988 71.9066 29.3835C71.3445 28.8683 71.0277 28.1701 71.0253 27.4414V25.6539C71.0277 24.9252 71.3445 24.227 71.9066 23.7118C72.4687 23.1965 73.2304 22.9061 74.0253 22.9039C74.8202 22.9061 75.5819 23.1965 76.144 23.7118C76.7061 24.227 77.023 24.9252 77.0253 25.6539V26.6164H71.0253M91.4913 19.1914V28.8164C91.4793 28.9998 91.5099 29.1835 91.581 29.3554C91.6521 29.5272 91.7622 29.6832 91.9039 29.8132C92.0457 29.9431 92.2159 30.044 92.4034 30.1092C92.5908 30.1744 92.7912 30.2024 92.9913 30.1914H93.4413M67.5483 45.4319C67.2968 45.8496 66.9274 46.1977 66.4788 46.4396C66.0302 46.6815 65.5188 46.8084 64.9983 46.8069C64.2034 46.8047 63.4417 46.5143 62.8796 45.999C62.3175 45.4838 62.0007 44.7856 61.9983 44.0569V42.2694C62.0007 41.5407 62.3175 40.8425 62.8796 40.3273C63.4417 39.812 64.2034 39.5216 64.9983 39.5194C65.5188 39.518 66.0302 39.6448 66.4788 39.8867C66.9274 40.1286 67.2968 40.4767 67.5483 40.8944M96.7473 45.4319C96.4957 45.8495 96.1263 46.1975 95.6777 46.4394C95.2291 46.6813 94.7178 46.8082 94.1973 46.8069C93.4024 46.8047 92.6407 46.5143 92.0786 45.999C91.5165 45.4838 91.1997 44.7856 91.1973 44.0569V42.2694C91.1997 41.5407 91.5165 40.8425 92.0786 40.3273C92.6407 39.812 93.4024 39.5216 94.1973 39.5194C94.7178 39.5181 95.2291 39.645 95.6777 39.8869C96.1263 40.1288 96.4957 40.4768 96.7473 40.8944M87.0018 27.4414C86.9995 28.1701 86.6826 28.8683 86.1205 29.3835C85.5584 29.8988 84.7967 30.1892 84.0018 30.1914C83.2069 30.1892 82.4452 29.8988 81.8831 29.3835C81.321 28.8683 81.0042 28.1701 81.0018 27.4414V25.6539C81.0042 24.9252 81.321 24.227 81.8831 23.7118C82.4452 23.1965 83.2069 22.9061 84.0018 22.9039C84.7967 22.9061 85.5584 23.1965 86.1205 23.7118C86.6826 24.227 86.9995 24.9252 87.0018 25.6539M87.0018 30.1914V22.9039M87.2388 44.0569C87.2365 44.7856 86.9196 45.4838 86.3575 45.999C85.7954 46.5143 85.0337 46.8047 84.2388 46.8069C83.4439 46.8047 82.6822 46.5143 82.1201 45.999C81.558 45.4838 81.2412 44.7856 81.2388 44.0569V42.2694C81.2412 41.5407 81.558 40.8425 82.1201 40.3273C82.6822 39.812 83.4439 39.5216 84.2388 39.5194C85.0337 39.5216 85.7954 39.812 86.3575 40.3273C86.9196 40.8425 87.2365 41.5407 87.2388 42.2694M87.2388 46.8069V39.5194M74.5053 46.8069C73.7104 46.8047 72.9487 46.5143 72.3866 45.999C71.8245 45.4838 71.5077 44.7856 71.5053 44.0569V42.2694C71.5077 41.5407 71.8245 40.8425 72.3866 40.3273C72.9487 39.812 73.7104 39.5216 74.5053 39.5194C75.3002 39.5216 76.0619 39.812 76.624 40.3273C77.1861 40.8425 77.503 41.5407 77.5053 42.2694V44.0569C77.503 44.7856 77.1861 45.4838 76.624 45.999C76.0619 46.5143 75.3002 46.8047 74.5053 46.8069Z" stroke="#2196F3" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M34.5 44.75C40.7132 44.75 45.75 39.7132 45.75 33.5C45.75 27.2868 40.7132 22.25 34.5 22.25C28.2868 22.25 23.25 27.2868 23.25 33.5C23.25 39.7132 28.2868 44.75 34.5 44.75Z" stroke="#2196F3" stroke-width="1.5" />
              <path d="M37.3125 30.6875L31.6875 36.3125M31.6875 30.6875L37.3125 36.3125" stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" />
            </svg>

          )}

          <Select
            isSearchable={false}
            styles={ReactSelectStyles.initialStyles}
            options={optionsResources}
            isOptionDisabled={o => !!o.disabled}
            value={dataPatient.getProviderPatientById!.healthCoachingStatus ? optionsResources.find(x => x.value === dataPatient.getProviderPatientById!.healthCoachingStatus) : null}
            onChange={(option: IOptionsResources | null, actionMeta: ActionMeta<IOptionsResources>) => {
              toastId.current = toast(<Flex flexDirection={'column'}>
                <Text fontWeight={400}>Health Coaching status change</Text>
                <Text fontWeight={300}>Changing health coaching for patient {dataPatient.getProviderPatientById?.athenaId} to {!option || !option.label ? '' : option.label}</Text>
              </Flex>, { autoClose: false, isLoading: true, closeButton: false });
              setHealthCoachStatus({
                variables: {
                  athenaId: dataPatient.getProviderPatientById!.athenaId,
                  status: !option || !option.value ? '' : option.value
                }
              })
            }}
            components={{ Option }} />
        </Flex>
      )}

      <MenuContainer ml={3} mr={3} style={{ alignItems: !!isMinimized ? 'flex-start' : 'center' }}>
        <MenuTrigger onClick={onClick}>
          <svg width="26" height="26" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.9995 25.0001L29.9978 30.0001H34.9995V33.3334H29.9978L29.9995 38.3334H26.6662L26.6645 33.3334H21.6662V30.0001H26.6645L26.6662 25.0001H29.9995ZM18.3328 30.0001V33.3334H4.99951V30.0001H18.3328ZM34.9995 18.3334V21.6667H4.99951V18.3334H34.9995ZM34.9995 6.66675V10.0001H4.99951V6.66675H34.9995Z" fill="white" />
          </svg>
        </MenuTrigger>
        <Menu className={isActive ? 'active' : 'inactive'}
          ref={dropdownRef}>
          <MenuEntry className={dataPatient?.getProviderPatientById?.stripeId ? 'menyentry' : 'menyentrydisabled'} onClick={() => {
            setIsActive(false)
            if (!dataPatient?.getProviderPatientById?.stripeId) return
            if (!window) return
            window.open(`https://dashboard.stripe.com/${isPreviewMode ? 'test/' : ''}customers/${dataPatient?.getProviderPatientById?.stripeId}`, '_blank')?.focus();
          }}>Stripe profile</MenuEntry>
          <MenuEntry className="menyentry" onClick={() => {
            setIsActive(false)

            toastId.current = toast(<Flex flexDirection={'column'}>
              <Text fontWeight={400}>Start Impersonation</Text>
              <Text fontWeight={300}>for patient {dataPatient.getProviderPatientById?.athenaId}</Text>
            </Flex>, { autoClose: false, isLoading: true, closeButton: false });

            impersonate()
            // window.open(`${webappRoute}/admin-impersonate-patient/${dataPatient?.getProviderPatientById?.athenaId}`, '_blank')?.focus();
          }}>Impersonate patient</MenuEntry>
          <MenuEntry className="menyentry" onClick={() => {
            ReactTooltip.hide(chartAlertRef.current)
            setIsActive(false)
            setIsPickForm(true)
          }}>Create a note</MenuEntry>
          <MenuEntry className="menyentry" onClick={() => {
            setIsActive(false)
            window.open(`${webappRoute}/?vp=${dataPatient?.getProviderPatientById?.athenaId}`, '_blank')?.focus();
          }}>Admin view</MenuEntry>
          <MenuEntry className={dataPatient?.getProviderPatientById?.perpetualPhysicianConvoId ? 'menyentry' : 'menyentrydisabled'} onClick={() => {
            setIsActive(false)
            if (!dataPatient?.getProviderPatientById?.perpetualPhysicianConvoId) return
            window.open(`https://secure.helpscout.net/conversation/${dataPatient?.getProviderPatientById?.perpetualPhysicianConvoId}`, '_blank')?.focus();
          }}>HS physician convo</MenuEntry>
          <MenuEntry className="menyentry" onClick={() => {
            setIsActive(false)

            setIsSendReplacementKit(true)
            // window.open(`${webappRoute}/admin-impersonate-patient/${dataPatient?.getProviderPatientById?.athenaId}`, '_blank')?.focus();
          }}>Req. Replacement Kit</MenuEntry>
          <MenuEntry className="menyentry" onClick={() => {
            setIsActive(false)
            // if (!dataPatient?.getProviderPatientById?.perpetualPhysicianConvoId) return
            window.open(`https://airtable.com/apphrkNDPiZ4DkSbj/tblTXo7CShNqjTOnt/viw9woKss6yWSl6va?blocks=hide`, '_blank')?.focus();
            // window.open(`https://airtable.com/apphrkNDPiZ4DkSbj/tblTXo7CShNqjTOnt/viw9kxgxHgEioSqPG?blocks=hide`, '_blank')?.focus();
          }}>Airtable Order Mgmt</MenuEntry>
          <MenuEntry className={dataPatient?.getProviderPatientById?.phone ? 'menyentry' : 'menyentrydisabled'} onClick={() => {
            setIsActive(false)
            if (!!dataPatient?.getProviderPatientById?.phone) {
              window.open(`dialpad://${dataPatient?.getProviderPatientById?.phone.replace(/[^\d+]/g, '')}?launchMinimode=1&crmLogging=0&showDispositions=1&customData=${encodeURI(`${dataPatient?.getProviderPatientById?.firstname} ${dataPatient?.getProviderPatientById?.lastname}` || '')}`);
            }
          }}>Call {formatPhoneNumber(dataPatient.getProviderPatientById?.phone)}</MenuEntry>
          <MenuEntry className={dataPatient?.getProviderPatientById?.phone ? 'menyentry' : 'menyentrydisabled'} onClick={() => {
            setIsActive(false)
            if (!!dataPatient?.getProviderPatientById?.phone) {
              setIsSendSms(true)
            }
          }}>Send SMS to patient</MenuEntry>

          {!!membershipData && (
            <MenuEntry className={dataPatient?.getProviderPatientById?.helpscoutId && dataPatient?.getProviderPatientById?.athenaId ? 'menyentry' : 'menyentrydisabled'} onClick={() => {
              if (!!dataPatient?.getProviderPatientById?.athenaId) {
                setIsActive(false)
                initMemberConvoMutate({
                  variables: {
                    athenaId: dataPatient.getProviderPatientById.athenaId
                  }
                })
              }
            }}>Init. Member Convo</MenuEntry>
          )}

          <MenuEntry className="menyentry" onClick={() => {
            setIsActive(false)
            // if (!dataPatient?.getProviderPatientById?.perpetualPhysicianConvoId) return
            window.open(`https://docs.google.com/document/d/17h4zGd_NB9GyKku3XIwZrPwAGQkDsQvFuJ8Jv_t_xME/edit`, '_blank')?.focus();
            // window.open(`https://airtable.com/apphrkNDPiZ4DkSbj/tblTXo7CShNqjTOnt/viw9kxgxHgEioSqPG?blocks=hide`, '_blank')?.focus();
          }}>Crisis Protocol</MenuEntry>


        </Menu>
      </MenuContainer>
      {isPickForm && (
        <PickNewNote onCancel={() => setIsPickForm(false)} onSelected={frm => {
          setIsPickForm(false)
          navigate(`/new-note/${dataPatient?.getProviderPatientById?.athenaId}/${frm.formId}`)
        }} />
      )}
      {!!isUnableToActivateHC && (
        <EnhancedModal
          isOpen={!!isUnableToActivateHC}
          onClose={() => setIsUnableToActivateHC(false)}
        >
          <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
            <Heading mb={4}>Unable to proceed</Heading>
            <Text>Patient doesn't have an Athena ID.</Text>
            <Text textAlign={'center'}>Only patient with an Athena ID can have the flag Health Coaching.</Text>
            <Button variant={'primary'} mt={4}
              onClick={() => setIsUnableToActivateHC(false)}>Ok</Button>
          </Flex>
        </EnhancedModal>
      )}
      {!!showListConversations && !!dataPatient?.getProviderPatientById?.athenaId && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setShowListConversations(false);
          }}
          onEscapeKeydown={() => {
            setShowListConversations(false);
          }}
        >
          <SpecialModalBackground
            style={{ zIndex: 1000 }}
            onClick={() => {
              setShowListConversations(false);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} style={{ overflowY: 'hidden', padding: 0, width: 'min(95vw, 1250px)' }}>
                <ViewListConversations athenaId={dataPatient?.getProviderPatientById?.athenaId} onClose={() => setShowListConversations(false)} />
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {!!isIntakeWarningVisible && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsIntakeWarningVisible(false)
          }}
          onEscapeKeydown={() => {
            setIsIntakeWarningVisible(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsIntakeWarningVisible(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Heading textAlign={'center'} mb={4}>INTAKE</Heading>
                <Text mb={5} textAlign={'center'}>{!loadingIntakeStatus && dataIntakeStatus && !!dataIntakeStatus.healthCoachGetIntakeStatus && !!dataIntakeStatus.healthCoachGetIntakeStatus.message ? dataIntakeStatus.healthCoachGetIntakeStatus.message : `Patient's intake is either not completed or out of date`}</Text>
                <Flex alignItems="center" flexDirection="row" justifyContent={'center'}>
                  <Button variant="primary" width={'100px'} type="button" id="btn_login" onClick={() => setIsIntakeWarningVisible(false)}>
                    OK
                  </Button>
                </Flex>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}

      {!!dataPatient?.getProviderPatientById?.phone && !!isSendSms && (
        <Modal
          isOpen={!!isSendSms}
          onBackgroundClick={() => setIsSendSms(false)}
          onEscapeKeydown={() => setIsSendSms(false)}>
          <SendSms patientId={dataPatient.getProviderPatientById.athenaId || ''} defaultText=' ' id={formatPhoneNumber(dataPatient.getProviderPatientById?.phone) || dataPatient.getProviderPatientById?.phone} name={`${dataPatient?.getProviderPatientById.firstname} ${dataPatient?.getProviderPatientById.lastname}`} close={() => { setIsSendSms(false) }} />
        </Modal>
      )}
      {!!isSendReplacementKit && (
        <Modal
          isOpen={!!isSendReplacementKit}
          onBackgroundClick={() => setIsSendReplacementKit(false)}
          onEscapeKeydown={() => setIsSendReplacementKit(false)}>
          <Box style={{ margin: '0 auto', maxHeight: '90vh', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <RequestReplacementKit patientId={dataPatient.getProviderPatientById!.athenaId} close={() => setIsSendReplacementKit(false)} />
          </Box>
        </Modal>
      )}

      {!!isShowingWellnessPlan && dataPatient.getProviderPatientById?.user && (
        <EnhancedModal
          isOpen={!!isShowingWellnessPlan}
          onClose={() => setIsShowingWellnessPlan(false)}
        >
          <WellnessPlan patientId={dataPatient?.getProviderPatientById.user} onClose={() => setIsShowingWellnessPlan(false)} />
        </EnhancedModal>
      )}
    </Flex>
  )
}

export default PageTopBar

const Wrapper = styled(Flex)`
  overflow: auto;
  width: 800px;
  /* padding-right: 20px; */
  /* margin-right: 20px; */
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;